// Shared color palette + helpers for the OCR result view (MUI 5).
// Neutral palette that blends with the surrounding dashboard.

// Themed to match the dashboard sidebar: primary blue #007AFE with cool grays.
export const ocrPalette = {
  border: "#e5e5ea",
  surface: "#ffffff",
  bg: "#f4f4f7",
  text: "#1f1f24",
  muted: "#71717a",
  ok: "#0f6e56",
  okBg: "#e1f5ee",
  warn: "#854f0b",
  warnBg: "#faeeda",
  fail: "#a32d2d",
  failBg: "#fcebeb",
  accent: "#007afe",
  accentBg: "#e8f1ff",
  accentBorder: "#7fb5fd",
  accentHover: "#d4e6ff",
  purple: "#3c3489",
  purpleBg: "#eeedfe",
  grayBg: "#f0f0f3",
  grayText: "#52525b",
  rowActive: "#eaf3ff",
  hover: "#f5f5f8",
  imageBorder: "#d8d8de",
};

// Bounding-box overlay tones used by DocumentPreview.
export const bboxTone = {
  ok: { border: "#007afe", bg: "rgba(0, 122, 254, 0.14)" },
  warn: { border: "#ef9f27", bg: "rgba(239, 159, 39, 0.16)" },
  fail: { border: "#e24b4a", bg: "rgba(226, 75, 74, 0.16)" },
};

export function confColor(conf, threshold) {
  if (conf == null) return ocrPalette.muted;
  return conf >= threshold ? ocrPalette.ok : ocrPalette.warn;
}

export function statusColor(status) {
  if (status === "verified") return ocrPalette.ok;
  if (status === "review") return ocrPalette.warn;
  if (status === "failed") return ocrPalette.fail;
  return ocrPalette.muted;
}

export function statusText(status) {
  if (status === "verified") return "\u2713 Verified";
  if (status === "review") return "\u26A0 Review";
  if (status === "failed") return "\u2715 Failed";
  return "\u2014";
}

export function toneFor(field, threshold) {
  if (field.status === "failed") return "fail";
  if (field.status === "review" || field.confidence < threshold) return "warn";
  return "ok";
}
